import styled from 'styled-components';
import BannerBG from 'common/src/assets/image/hosting/pricing_banner.jpg';
import { themeGet } from 'styled-system';

const BannerWrapper = styled.section`
  background-image: url(${BannerBG});
  background-size: cover;
  background-repeat: no-repeat;
  text-align: center;
  color: #ffffff;
  display: flex;
  align-items: center;
  height: 40vh;

  .particle {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    @media (max-width: 767px) {
      display: none;
    }
  }

  .banner_container {
    color: #fff;
    position: relative;
    margin-left: auto;
    margin-right: 0px;
    margin-top: 70px;
    width: 100%;
    padding: 40px;
  }
  .title {
    font-weight: 600;
    font-size: 22px;
    margin-bottom: 10px;
  }
  .subtitle {
    margin-top: 10px;
    font-size: 14px;
  }
  .desc {
    font-size: 12px;
  }

  @media (min-width: 576px) {
    height: 45vh;
    .banner_container {
      margin-left: auto;
      margin-right: 0px;
      margin-top: 70px;
      width: 100%;
      padding: 40px;
    }
    .title {
      font-weight: 600;
      font-size: 24px;
      margin-bottom: 10px;
    }
    .subtitle {
      margin-top: 10px;
      font-size: 15px;
    }
    .desc {
      font-size: 13px;
    }
  }

  @media (min-width: 768px) {
    height: 50vh;
    .banner_container {
      color: #000;
      margin-left: auto;
      margin-right: 0px;
      margin-top: 70px;
      width: 100%;
      padding: 40px;
    }
    .title {
      font-weight: 600;
      font-size: 35px;
      margin-bottom: 10px;
    }
    .subtitle {
      margin-top: 10px;
      font-size: 20px;
    }
    .desc {
      font-size: 15px;
    }
  }

  @media (min-width: 992px) {
  }

  @media (min-width: 1200px) {
    height: 58vh;

    .banner_container {
      margin-left: auto;
      margin-right: 150px;
      margin-top: 70px;
      width: 800px;
      padding: 40px;
    }
    .title {
      font-size: 42px;
      margin-bottom: 10px;
    }
    .subtitle {
      margin-top: 40px;
      font-size: 24px;
    }
  }
`;

const BannerObject = styled.div`
  position: absolute;
  width: 50%;
  height: 100%;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  @media (max-width: 767px) {
    display: none;
  }
  .objectWrapper {
    margin-left: auto;
    position: relative;
    .dashboardWrapper {
      position: absolute;
      top: 0;
      right: 0;
      .chatObject {
        position: absolute;
        top: 20px;
        left: 120px;
      }
    }
  }
`;

const PricingList = styled.div`
  margin: 30px 0 60px 0;

  img {
    height: 20px;
    width: 20px;
    margin-right: 18px;
  }
`;

const SocialMedia = styled.div`
  z-index: 2;
  font-size: 12px;
  font-weight: 600;
  position: absolute;
  display: flex;
  justify-content: space-between;
  width: 20%;
  transform: rotate(-90deg);
  left: -125px;
  color: #fff;
  div {
    cursor: pointer;
  }
`;
const ListItem = styled.div`
  display: flex;
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0;
  }
  .price_list_icon {
    color: #3788f7;
    margin-right: 10px;
  }
`;

export { PricingList, ListItem, SocialMedia };

export default BannerWrapper;
